// import { useState, useEffect, useRef } from "react";
// import { Row, Col, Form } from "react-bootstrap";
// import { BsPencil, BsCheck, BsX } from "react-icons/bs";
// import axios from "axios";

// const OrganisationView = ({ data, organisationId, setOrganisationDetails }) => {
//     const [editedData, setEditedData] = useState(data);
//     const [industries, setIndustries] = useState([]);
//     const [countries, setCountries] = useState([]);
//     const [editField, setEditField] = useState(null);
//     const didFetchRef = useRef(false);
//     const [currency, setCurrency] = useState('AED');
//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchIndustries();
//             fetchCountries();
//             didFetchRef.current = true;
//         }
//     }, []);

//     const fetchIndustries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//             const origin = localStorage.getItem('user-origin');

//             const response = await axios.get(`${backendUrl}/api/industries`, {
//                 headers: { Authorization: `Bearer ${token}`,
//                 'Tenant-Origin': origin,
//             },
//                             skipLoader: true,

//             });
//             setIndustries(response.data.industry);
//         } catch (error) {
//             console.error("Error fetching industries:", error);
//         }
//     };

//     const fetchCountries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//             const origin = localStorage.getItem('user-origin');
//             const response = await axios.get(`${backendUrl}/api/countries`, {
//                 headers: { Authorization: `Bearer ${token}`,
//                 'Tenant-Origin': origin,
//             },
//                             skipLoader: true,

//             });
//             const allCountries = response.data.Data;

//             const sortedCountries = allCountries.sort((a, b) => {
//                 if (a.name === 'United Arab Emirates') return -1;
//                 if (b.name === 'United Arab Emirates') return 1;
//                 return a.name.localeCompare(b.name);
//             });
    
//             setCountries(sortedCountries); // Set sorted list
//             if (!editedData.country_id) {
//                 const uae = allCountries.find(c => c.name === 'United Arab Emirates');
//                 if (uae) {
//                     setEditedData(prev => ({
//                         ...prev,
//                         country_id: uae.id,
//                         currency: 'AED'
//                     }));
//                 }
//             }
//         } catch (error) {
//             console.error("Error fetching countries:", error);
//         }
//     };
    
   
//     const handleSave = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//             const origin = localStorage.getItem('user-origin');
    
//             const response = await axios.put(`${backendUrl}/api/organisation/${organisationId}`, editedData, {
//                 headers: { Authorization: `Bearer ${token}`,
//                 'Tenant-Origin': origin,
//             },
//             });
    
//             if (response.status === 200) {
//                 setOrganisationDetails((prev) => ({ ...prev, ...editedData }));
//                 setEditField(null);
//             }
//         } catch (error) {
//             console.error("Error saving organisation details:", error);
//         }
//     };
    
//     const handleChange = (e) => {
//         const { name, value } = e.target;
    
//         setEditedData((prevData) => {
//             let updatedData = { ...prevData, [name]: value };
    
//             if (name === "country_id") {
//                 const selectedCountry = countries.find(c => String(c.id) === value);
//                 updatedData.currency = selectedCountry?.name === "United Arab Emirates" ? "AED" : "USD";
//             }
            
//             console.log("Updated Data:", updatedData); // Debugging log
//             return updatedData;
//         });
//     };
    
    
//     useEffect(() => {
//         if (data && data.id !== editedData.id) {
//             setEditedData(data);
//         }
//     }, [data]);
    
          

//     const getIndustryName = (id) => {
//         if (!id) return "--";
//         const industry = industries.find((ind) => Number(ind.id) === Number(id)); // Ensure type matches
//         return industry ? industry.name : "--";
//     };
    
//     const getCountryName = (id) => {
//         if (!id || countries.length === 0) return "--";
//         const country = countries.find((coun) => Number(coun.id) === Number(id));
//         return country ? country.name : "--";
//     };
    
    

//     const fields = [
//         { name: "name", label: "Organisation Name", type: "text" },
//         { name: "employee_size", label: "Employee Size", type: "text" },
//         { name: "industry_id", label: "Industry", type: "select", options: industries.map((industry) => ({ value: industry.id, label: industry.name })), format: getIndustryName },
//         { name: "website", label: "Website", type: "textarea" },
//         { name: "org_type", label: "Type", type: "select", options: [{ value: "end customer", label: "End Customer" }, { value: "partner", label: "Partner" }] },
//         { name: "country_id", label: "Country", type: "select", options: countries.map((coun) => ({ value: coun.id, label: coun.name })), format: getCountryName },
//         { name: "address", label: "Address", type: "text" },

//         { name: "currency", label: "Currency", type: "text", readOnly: true },    ];

// //     return (
// //         <div className="p-3 font-size-13">
// // <Row>
// //         {fields.map((field, index) => (
// //             <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
// //                 <strong className="view-label">
// //                     {field.label}:
// //                 </strong>
// //                 <div className="editable-container d-flex align-items-center">
// //                     {editField === field.name ? (
// //                         <div className="d-flex align-items-center">
// //                             {field.type === "select" ? (
// //                                 <Form.Select
// //                                     value={editedData[field.name] || ""}
// //                                     onChange={handleChange}
// //                                     autoFocus
// //                                     className="form-control form-feild"
// //                                     name={field.name}
// //                                 >
// //                                     {field.options.map((option) => (
// //                                         <option key={option.value} value={option.value}>
// //                                             {option.label}
// //                                         </option>
// //                                     ))}
// //                                 </Form.Select>
// //                             ) : field.name === "website" ? ( // ✅ Use textarea for website field
// //                                 <Form.Control
// //                                     as="textarea"
// //                                     rows={3} // Adjust based on design
// //                                     value={editedData[field.name] || ""}
// //                                     onChange={handleChange}
// //                                     autoFocus
// //                                     className="custom-textarea form-feild"
// //                                     name={field.name}
// //                                 />
// //                             ) : (
// //                                 <Form.Control
// //                                     type="text"
// //                                     name={field.name}
// //                                     value={editedData[field.name] || ""}
// //                                     onChange={handleChange}
// //                                     autoFocus
// //                                     className="form-control form-feild"
// //                                     />
// //                             )}
// //                             <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
// //                             <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
// //                         </div>
// //                     ) : (
// //                         <div className="hover1" onClick={() => !field.readOnly && setEditField(field.name)}>
// //     <span className="hover-field1">
// //         {field.name === "industry_id"
// //             ? getIndustryName(editedData[field.name])
// //             : field.name === "country_id"
// //             ? getCountryName(editedData[field.name])
// //             : editedData[field.name] || "--"}
// //     </span>
// //     {!field.readOnly && <BsPencil className="text-primary pencil-icon1" />}
// // </div>

// //                     )}
// //                 </div>
// //             </Col>
// //         ))}
// //     </Row>


// //         </div>
// //     );
// // In OrganisationView component, update the return statement:
// return (
//     <div className="p-3">
//         <div className="row g-3">
//             {fields.map((field, index) => (
//                 <div className="col-md-6" key={index}>
//                     <div className="organisation-field-card p-3 bg-light rounded-3 h-100">
//                         <div className="d-flex justify-content-between align-items-start">
//                             <div className="flex-grow-1">
//                                 <label className="text-muted small fw-semibold mb-2 d-block">
//                                     {field.label}
//                                 </label>
//                                 {editField === field.name ? (
//                                     <div className="d-flex align-items-center gap-2">
//                                         {field.type === "select" ? (
//                                             <Form.Select
//                                                 value={editedData[field.name] || ""}
//                                                 onChange={handleChange}
//                                                 autoFocus
//                                                 className="form-control-sm"
//                                                 name={field.name}
//                                                 size="sm"
//                                             >
//                                                 {field.options.map((option) => (
//                                                     <option key={option.value} value={option.value}>
//                                                         {option.label}
//                                                     </option>
//                                                 ))}
//                                             </Form.Select>
//                                         ) : field.name === "website" ? (
//                                             <Form.Control
//                                                 as="textarea"
//                                                 rows={2}
//                                                 value={editedData[field.name] || ""}
//                                                 onChange={handleChange}
//                                                 autoFocus
//                                                 className="form-control-sm"
//                                                 name={field.name}
//                                             />
//                                         ) : (
//                                             <Form.Control
//                                                 type="text"
//                                                 name={field.name}
//                                                 value={editedData[field.name] || ""}
//                                                 onChange={handleChange}
//                                                 autoFocus
//                                                 className="form-control-sm"
//                                                 size="sm"
//                                             />
//                                         )}
//                                         <div className="d-flex gap-1">
//                                             <BsCheck 
//                                                 className="text-success cursor-pointer" 
//                                                 onClick={handleSave} 
//                                                 size={16}
//                                             />
//                                             <BsX 
//                                                 className="text-danger cursor-pointer" 
//                                                 onClick={() => setEditField(null)} 
//                                                 size={16}
//                                             />
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div 
//                                         className="d-flex align-items-center justify-content-between p-2 rounded hover-bg"
//                                         onClick={() => !field.readOnly && setEditField(field.name)}
//                                         style={{ 
//                                             cursor: field.readOnly ? 'default' : 'pointer',
//                                             minHeight: '38px'
//                                         }}
//                                     >
//                                         <span className="text-dark fw-medium">
//                                             {field.name === "industry_id"
//                                                 ? getIndustryName(editedData[field.name])
//                                                 : field.name === "country_id"
//                                                 ? getCountryName(editedData[field.name])
//                                                 : editedData[field.name] || "--"}
//                                         </span>
//                                         {!field.readOnly && (
//                                             <BsPencil className="text-primary ms-2" size={12} />
//                                         )}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             ))}
//         </div>
//     </div>
// );
// };



// export default OrganisationView;


import { useState, useEffect, useRef } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { BsPencil, BsCheck, BsX } from "react-icons/bs";
import axios from "axios";

const OrganisationView = ({ data, organisationId, setOrganisationDetails }) => {
    const [editedData, setEditedData] = useState(data);
    const [industries, setIndustries] = useState([]);
    const [countries, setCountries] = useState([]);
    const [editField, setEditField] = useState(null);
    const didFetchRef = useRef(false);
    const [currency, setCurrency] = useState('AED');
    
    useEffect(() => {
        if (!didFetchRef.current) {
            fetchIndustries();
            fetchCountries();
            didFetchRef.current = true;
        }
    }, []);

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const token = JSON.parse(localStorage.getItem("user-info"))?.token;
            const origin = localStorage.getItem('user-origin');

            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setIndustries(response.data.industry);
        } catch (error) {
            console.error("Error fetching industries:", error);
        }
    };

    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const token = JSON.parse(localStorage.getItem("user-info"))?.token;
            const origin = localStorage.getItem('user-origin');
            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            const allCountries = response.data.Data;

            const sortedCountries = allCountries.sort((a, b) => {
                if (a.name === 'United Arab Emirates') return -1;
                if (b.name === 'United Arab Emirates') return 1;
                return a.name.localeCompare(b.name);
            });
    
            setCountries(sortedCountries);
            if (!editedData.country_id) {
                const uae = allCountries.find(c => c.name === 'United Arab Emirates');
                if (uae) {
                    setEditedData(prev => ({
                        ...prev,
                        country_id: uae.id,
                        currency: 'AED'
                    }));
                }
            }
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
    };
    
    const handleSave = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const token = JSON.parse(localStorage.getItem("user-info"))?.token;
            const origin = localStorage.getItem('user-origin');
    
            const response = await axios.put(`${backendUrl}/api/organisation/${organisationId}`, editedData, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
    
            if (response.status === 200) {
                setOrganisationDetails((prev) => ({ ...prev, ...editedData }));
                setEditField(null);
            }
        } catch (error) {
            console.error("Error saving organisation details:", error);
        }
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
    
        setEditedData((prevData) => {
            let updatedData = { ...prevData, [name]: value };
    
            if (name === "country_id") {
                const selectedCountry = countries.find(c => String(c.id) === value);
                updatedData.currency = selectedCountry?.name === "United Arab Emirates" ? "AED" : "USD";
            }
            
            return updatedData;
        });
    };
    
    useEffect(() => {
        if (data && data.id !== editedData.id) {
            setEditedData(data);
        }
    }, [data]);
    
    const getIndustryName = (id) => {
        if (!id) return "--";
        const industry = industries.find((ind) => Number(ind.id) === Number(id));
        return industry ? industry.name : "--";
    };
    
    const getCountryName = (id) => {
        if (!id || countries.length === 0) return "--";
        const country = countries.find((coun) => Number(coun.id) === Number(id));
        return country ? country.name : "--";
    };

    const fields = [
        { name: "name", label: "Organisation Name", type: "text", required: true },
        { name: "employee_size", label: "Employee Size", type: "text" },
        { name: "industry_id", label: "Industry", type: "select", options: industries.map((industry) => ({ value: industry.id, label: industry.name })), format: getIndustryName },
        { name: "website", label: "Website", type: "textarea" },
        { name: "org_type", label: "Type", type: "select", options: [{ value: "end customer", label: "End Customer" }, { value: "partner", label: "Partner" }] },
        { name: "country_id", label: "Country", type: "select", options: countries.map((coun) => ({ value: coun.id, label: coun.name })), format: getCountryName },
        { name: "address", label: "Address", type: "text" },
        { name: "currency", label: "Currency", type: "text", readOnly: true },
    ];

    return (
        <div className="org-view-container">
            <div className="row g-4">
                {fields.map((field, index) => (
                    <div className="col-xl-6" key={index}>
                        <div className="org-field-card">
                            <div className="org-field-header">
                                <label className="org-field-label">
                                    {field.label}
                                    {field.required && <span className="text-danger"> *</span>}
                                </label>
                            </div>
                            
                            <div className="org-field-content">
                                {editField === field.name ? (
                                    <div className="org-edit-mode">
                                        <div className="org-input-container">
                                            {field.type === "select" ? (
                                                <Form.Select
                                                    value={editedData[field.name] || ""}
                                                    onChange={handleChange}
                                                    autoFocus
                                                    className="form-select-sm"
                                                    name={field.name}
                                                >
                                                    <option value="">Select {field.label}</option>
                                                    {field.options.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            ) : field.name === "website" ? (
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    value={editedData[field.name] || ""}
                                                    onChange={handleChange}
                                                    autoFocus
                                                    className="form-control-sm"
                                                    name={field.name}
                                                    placeholder={`Enter ${field.label.toLowerCase()}`}
                                                />
                                            ) : (
                                                <Form.Control
                                                    type={field.type}
                                                    name={field.name}
                                                    value={editedData[field.name] || ""}
                                                    onChange={handleChange}
                                                    autoFocus
                                                    className="form-control-sm"
                                                    placeholder={`Enter ${field.label.toLowerCase()}`}
                                                    readOnly={field.readOnly}
                                                />
                                            )}
                                        </div>
                                        {/* <div className="org-edit-actions">
                                            <button 
                                                className="btn btn-success btn-sm org-action-btn"
                                                onClick={handleSave}
                                                title="Save"
                                            >
                                                <BsCheck size={14} />
                                            </button>
                                            <button 
                                                className="btn btn-light btn-sm org-action-btn"
                                                onClick={() => setEditField(null)}
                                                title="Cancel"
                                            >
                                                <BsX size={14} />
                                            </button>
                                        </div> */}
                                    </div>
                                ) : (
                                    <div 
                                        className={`org-view-mode ${!field.readOnly ? 'org-editable-field' : ''}`}
                                    >
                                        <div className="org-field-value">
                                            <span className="org-value-text">
                                                {field.name === "industry_id"
                                                    ? getIndustryName(editedData[field.name])
                                                    : field.name === "country_id"
                                                    ? getCountryName(editedData[field.name])
                                                    : editedData[field.name] || (
                                                        <span className="text-muted">Not set</span>
                                                    )}
                                            </span>
                                        </div>
                                        {/* {!field.readOnly && (
                                            <div className="org-field-actions">
                                                <BsPencil 
                                                    className="org-edit-icon" 
                                                    size={12}
                                                    title={`Edit ${field.label}`}
                                                />
                                            </div>
                                        )} */}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OrganisationView;